<template>
  <div class="group-manage-detail conmon-top">
    <el-container>
      <!--左侧分组-->
      <el-aside class="left-menu-item">
        <div class="group-detail" style="box-sizing: border-box">
          <div class="title" style="font-size:14px">
            <i class="iconfont icon-icon-liebiao" style="color:#333;font-size:12px;margin-right:8px"></i>
            群组详情
          </div>
          <div class="detail-item">
            <div class="label">群组名称:</div>
            <div class="value">{{ query.name }}</div>
          </div>
          <div class="detail-item">
            <div class="label">类型:</div>
            <div class="value">
              {{ groupsType[query.type] }}
            </div>
          </div>
          <div class="detail-item">
            <div class="label">客户人数:</div>
            <div class="value" v-if="query.number > -1">
              {{ customerCount }}
              <i v-if="type === 1" class="el-icon-refresh refresh" title="刷新客户" @click="refreshCustomer"></i>
            </div>
            <div class="value" v-if="query.number == -1">
              <span style="color: #FFA873">
                <i class="el-icon-time"></i>
                正在统计中
              </span>
            </div>
          </div>
          <div class="detail-item">
            <div class="label">最后更新时间:</div>
            <div class="value">{{ query.update_time | formatDate }}</div>
          </div>
          <div class="detail-item" style="border-bottom: none">
            <div class="label">创建日期:</div>
            <div class="value">{{ query.create_time | formatDate }}</div>
          </div>
        </div>
        <!--群组条件（动态群组有）-->
        <!--<div v-if="type === 1" class="group-detail" style="padding-bottom: 10px;margin-top: 10px">-->
          <!--<div class="title">-->
            <!--<i class="iconfont icon-icon-dingdanjilu" style="color: #4882ff"></i>-->
            <!--群组条件-->
          <!--</div>-->
          <!--<div class="terms">{{ queryTerms }}</div>-->
        <!--</div>-->
      </el-aside>
      <!--右侧列表-->
      <div style="padding: 0;width: calc(100% - 300px)">
        <div class="base-input ovf-hd" style="margin-bottom: 10px">
          <el-row class="search-title">
            <el-col :span="5" class="table-title">
              <i class="el-icon-search" style="font-weight: bold;"></i>
              <span class="order-list-search-span">筛选查询</span>
            </el-col>
            <el-col :span="19" class="text-align-right">
              <el-button class="search-open-close" type="text" v-if="!isHigher" @click="hide=!hide">{{ hide? '收起查询':'展开查询' }}</el-button>
              <i v-if="hide === true && !isHigher" class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
              <i v-if="hide === false && !isHigher" class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
              <el-button class="search-btn-new" type="primary" size="small" v-if="!isHigher" @click="startLoad">查询</el-button>
            </el-col>
          </el-row>
          <el-row class="search-content" v-show="hide" v-if="!isHigher" style="line-height: 50px">
            <el-col :span="24" class="text-align-left common-search-formtype" style="margin-left: 22px;">
              <span style="margin-left: 26px;">创建时间：</span>
              <el-date-picker
                style="width: 370px!important;"
                class="operationTime operationTimePicker"
                v-model="timeaa"
                type="datetimerange"
                @change="consoles"
                range-separator="至"
                :default-time="['00:00:00', '23:59:59']"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-col>
          </el-row>
          <!--高级查询-->
          <el-row class="search-content" style="min-height: 210px;height: auto" v-if="isHigher">
            <div style="text-align: left;height: 10px" class="hei-ser">
              <el-button type="primary" :disabled="isDisabled" class="add-btn" style="border: none;margin-left: 0;margin-right: 32px" @click="saveThis">保存</el-button>
              <el-button type="primary" style="margin-right: 16px" class="add-btn" @click="closeHigherSearch">关闭高级查询</el-button>
              <el-button type="primary" style="margin-right: 16px" class="add-btn" @click="startPreView">开始查询</el-button>
            </div>
            <div style="text-align: left;padding-bottom: 10px">
              <span style="margin-left: 20px">查询条件：</span>
            </div>
            <higher-search class="common-search-formtype customer-manage-higher-search" :forSonTerms="forSonTerms" v-bind:allRelationship="allRelationship" @change="getAllTerms" style="margin-top: 10px"></higher-search>
          </el-row>
        </div>
        <el-row class="search-title common-table-top" style="padding-right: 0">
          <el-col :span="5" class="table-title">
            <i class="el-icon-document" style="font-weight: bold;"></i>
            <span>客户列表</span>
          </el-col>
          <el-col :span="19" class="text-align-right">
            <!--<div class="add-btn">导出客户</div>-->
            <el-button type="primary" class="add-btn btn-right" @click="deleteGroup">删除群组</el-button>
            <el-button type="primary" v-if="type === 1" style="margin-right: 16px" class="add-btn" @click="edit">编辑</el-button>
            <el-button type="primary" v-if="type === 2" style="margin-right: 16px" class="add-btn" @click="addNewCustomer">添加客户</el-button>
            <el-button type="primary" class="add-btn" style="margin-right: 16px" @click="downloadFiles">导出</el-button>
          </el-col>
        </el-row>
        <!--初始列表-->
        <el-table v-if="isShow === true" ref="multipleTable" key="tableData" :data="tableData" class="table">
          <!-- <el-table-column label="头像" width="70">
            <template slot-scope="scope">
              <img :src="scope.row.avatar | showImgUrl" alt="" style="width: 40px;display: block;margin: 0 auto;border-radius: 50%">
            </template>
          </el-table-column> -->
          <el-table-column label="客户" min-width="120">
            <template slot-scope="scope">
              <router-link :to="{ name: 'customerDetail', query: { id: scope.row.id }}" class="op-link" style="margin-left: 0;color:#4882ff;text-decoration: none">
                <img :src="scope.row.avatar | showImgUrl" alt="" style="width: 32px;height: 32px;display: block;border-radius: 50%;text-align:left;float:left;margin-right:10px;margin-left: 15px;">
                <span v-if="scope.row.realname" style="line-height: 32px;">{{ scope.row.realname }}</span>
                <span v-if="scope.row.realname === ''" style="line-height: 32px;">{{ scope.row.nickname }}</span>
                <span v-if="scope.row.realname === '' && scope.row.nickname === ''" style="line-height: 32px;">未知</span>
              </router-link>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" width="175">
            <template slot-scope="scope">
              <span v-if="scope.row.join_date === 0">{{ scope.row.create_time | formatDate }}</span>
              <span v-else>{{ scope.row.join_date | formatDate }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="source_content" label="初始来源内容" width=""></el-table-column> -->
          <el-table-column label="城市" width="">
            <template slot-scope="scope">
              {{ scope.row.province }}{{ scope.row.city }}
            </template>
          </el-table-column>
          <el-table-column label="当前等级" width="">
            <template slot-scope="scope">
              <span v-if="scope.row.stage">{{ scope.row.stage }}</span>
              <span v-if="scope.row.stage === ''">未知</span>
            </template>
          </el-table-column>
          <el-table-column prop="source" label="初始来源" width=""></el-table-column>
          <el-table-column label="操作" width="80" style="display: flex;justify-content: center">
            <template slot-scope="scope">
              <router-link :to="{ name: 'customerDetail', query: { id: scope.row.id }}" class="op-link" style="margin-left: 0;color:#4882ff;text-decoration: none">
                查看
              </router-link>
            </template>
          </el-table-column>
        </el-table>
        <!--高级查询列表-->
        <el-table v-if="isShow === false" ref="multipleTable" key="searchData" :data="searchData" class="table">
          <el-table-column label="头像" width="70">
            <template slot-scope="scope">
              <router-link :to="{ name: 'customerDetail', query: { id: scope.row.id }}" class="op-link" style="margin-left: 0;color:#4882ff;text-decoration: none">
                <img :src="scope.row.avatar | showImgUrl" alt="" style="width: 40px;display: block;margin: 0 auto;border-radius: 50%">
              </router-link>
            </template>
          </el-table-column>
          <el-table-column label="客户" width="80">
            <template slot-scope="scope">
              <router-link :to="{ name: 'customerDetail', query: { id: scope.row.id }}" class="op-link" style="margin-left: 0;color:#4882ff;text-decoration: none">
                <span v-if="scope.row.realname">{{ scope.row.realname }}</span>
                <span v-if="scope.row.realname === ''">{{ scope.row.nickname }}</span>
                <span v-if="scope.row.realname === '' && scope.row.nickname === ''">未知</span>
              </router-link>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" width="135">
            <template slot-scope="scope">
              <span v-if="scope.row.join_date === 0">{{ scope.row.create_time | formatDate }}</span>
              <span v-else>{{ scope.row.join_date | formatDate }}</span>
            </template>
          </el-table-column>
          <!--<el-table-column prop="source_content" label="初始来源内容" width=""></el-table-column>-->
          <el-table-column label="城市" width="">
            <template slot-scope="scope">
              {{ scope.row.province_name }}{{ scope.row.city_name }}
            </template>
          </el-table-column>
          <el-table-column prop="stage_name" label="当前等级" width=""></el-table-column>
          <el-table-column prop="source_name" label="初始来源" width=""></el-table-column>
          <el-table-column label="操作" width="80" style="display: flex;justify-content: center">
            <template slot-scope="scope">
              <router-link :to="{ name: 'customerDetail', query: { id: scope.row.id }}" class="op-link" style="margin-left: 0;color:#4882ff;text-decoration: none">
                查看
              </router-link>
            </template>
          </el-table-column>
        </el-table>
        <div class="table-foot" style="text-align: right">
          <span style="font-weight: 400;color: #606266;font-size: 13px;line-height: 40px;">共 {{ totalCount }} 条</span>
          <el-pagination
            class="table-foot-pagination"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="limit"
            :current-page="page"
            layout="prev, pager, next"
            :total="len">
          </el-pagination>
        </div>
      </div>
    </el-container>

    <!--添加群组分组弹窗-->
    <el-dialog class="cellDialog" title="创建群组分组" :visible.sync="adddialog" width="400px">
      <el-form ref="addForm" :model="addForm">
        <el-form-item label="分组名称:" :label-width="addLabelWidth">
          <el-input class="stockInput" type="text" v-model="addForm.name" auto-complete="off" placeholder="输入群组分组名称"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn" type="primary">确 定</el-button>
      </div>
    </el-dialog>
    <!--编辑群组分组弹窗-->
    <el-dialog class="cellDialog" title="编辑群组分组" :visible.sync="editdialog" width="400px">
      <el-form ref="editForm" :model="editForm">
        <el-form-item label="分组名称:" :label-width="addLabelWidth">
          <el-input class="stockInput" type="text" v-model="editForm.name" auto-complete="off" placeholder="输入群组分组名称"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button @click="editdialog = false" style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn" type="primary">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { exportCustomer, getGroupList, getWechatPublicListForNode, getQrCodeList, WePagesList, getBigWheelList, getMessageListForNode, getCustomerAttributeList, getCustomerStage, getSourceData, getGroupDetail, refreshCustomer, getCustomerList, editGroupManageDetail, addGroupManageDetail, deleteGroup } from '@/api/customer.js'
import HigherSearch from './../common/higher-search.vue'
import { regionData, CodeToText, TextToCode } from 'element-china-area-data'
export default {
  name: 'groupManageDetil',
  data () {
    return {
      downloadUse: 0,
      isHigher: false,
      isShow: true,
      tableData: [],
      searchData: [],
      limit: 10,
      totalCount: 0,
      customerCount: 0,
      adddialog: false,
      editdialog: false,
      addForm: {
        name: ''
      },
      editForm: {
        name: ''
      },
      addLabelWidth: '80px',
      dialogType: 0,
      editId: '',
      page: 1,
      hide: true,
      isDisabled: false,
      closeChoose: '收起筛选',
      search: {
        start_time: '',
        end_time: ''
      },
      groupsType: {
        1: '动态群组',
        2: '静态群组'
      },
      allTerms: {},
      downloadSearch: {},
      allTermsCopy: {},
      queryTerms: '',
      type: 0,
      query: {},
      timeaa: null,
      lastId: 0,
      saveType: 0,
      allRelationship: '',
      forSonTerms: [
        {
          inOperator: 'and',
          terms: [
            {
              attr: 'attr',
              attr_label: '真实姓名',
              relationship: '',
              relationOptions: [
                {
                  value: '=',
                  label: '等于'
                }, {
                  value: '!=',
                  label: '不等于'
                }, {
                  value: 'contain',
                  label: '包含'
                }, {
                  value: 'empty',
                  label: '为空'
                },
                {
                  value: 'not empty',
                  label: '不为空'
                }
              ],
              value: null,
              original_id: null,
              eventAttributeList: [],
              activitiesTwo: [],
              templatesTwo: [],
              wepageTwo: [],
              eventAttrOptions: [
                {
                  attributeContent: '',
                  relationOptions: [],
                  sources: [],
                  eventAttrValueOptions: [],
                  attributeRelation: '',
                  attr_type: '',
                  attrValTimeStart: '',
                  attrValTimeEnd: '',
                  attributeValueStart: '',
                  attributeValueEnd: '',
                  attributeValue: ''
                }
              ],
              optionOther: null,
              qrcodeOptions: null,
              templateOption: null,
              qrcode: null,
              offline_qrcode: null,
              template_id: null,
              leave_word: null,
              public_reply_type_all: {
                reply_type: '不限',
                reply_content: ''
              },
              eventLimitTime: false,
              eventLimitTimes: false,
              eventLimitAttr: false,
              eventTimeRelation: '',
              eventDateStart: '',
              eventDateEnd: '',
              happenedTimes: '',
              start_time: '',
              end_time: '',
              selectedOptions: ['attr', 'realname@input']
            }
          ]
        }
      ],
      result: [],
      identities: [],
      len: 0,
      isShowSearchRes: false
    }
  },
  components: {
    'higher-search': HigherSearch
  },
  methods: {
    consoles(value) {
      console.log(this.timeaa)
    },
    // 开始初级查询
    startLoad() {
      if (this.timeaa === null) {
        _g.toastMsg('error', '请选择创建时间')
        return
      }
      this.downloadUse = 1
      this.load()
    },
    // 删除群组
    deleteGroup() {
      let id = this.$route.query.id
      this.$confirm('确认删除该群组?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteGroup(id).then((res) => {
          if (res.data.code === 0) {
            this.load()
            _g.toastMsg('success', '删除群组成功')
            router.push('/home/group-manage')
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    // 开始预览
    startPreView() {
      this.isShowSearchRes = false
      this.downloadUse = 2
      this.preView()
    },
    // 预览
    preView() {
      // 判断是否为空
      if (this.isShowSearchRes === false) {
        for (let i in this.allTerms.termsGroup) {
          let item = this.allTerms.termsGroup[i]
          for (let j in item.terms) {
            if (item.terms[j].selectedOptions[0] === 'attr') {
              if (item.terms[j].relationship === '') {
                _g.toastMsg('error', '请选择相对关系')
                return
              }
            }
            // 判断客户属性是否为空
            if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not empty') {
              if (item.terms[j].attr === 'attr') {
                // 判断是否是时间且为区间
                if (item.terms[j].selectedOptions[1].split('@')[1] === 'datePicker' || item.terms[j].selectedOptions[1].split('@')[1] === 'dateTimePicker') {
                  if (item.terms[j].relationship === 'gtele') {
                    if (item.terms[j].start_time === '') {
                      _g.toastMsg('error', '客户属性-' + item.terms[j].attr_label + '      起始时间值不能为空')
                      return
                    }
                    if (item.terms[j].end_time === '') {
                      _g.toastMsg('error', '客户属性-' + item.terms[j].attr_label + '      结束时间值不能为空')
                      return
                    }
                  } else if (item.terms[j].value === '' || item.terms[j].value === null || item.terms[j].value.length === 0) {
                    _g.toastMsg('error', '客户属性-' + item.terms[j].attr_label + '      值不能为空')
                    return
                  }
                } else if (item.terms[j].value === '' || item.terms[j].value === null || item.terms[j].value.length === 0) {
                  _g.toastMsg('error', '客户属性-' + item.terms[j].attr_label + '      值不能为空')
                  return
                }
              }
            }
            // 判断群组是否为空
            if (item.terms[j].attr === 'group') {
              if (item.terms[j].value === '' || item.terms[j].value === null) {
                _g.toastMsg('error', '群组-' + item.terms[j].attr_label + '      值不能为空')
                return
              }
            }
            // 判断客户事件是否为空
            if (item.terms[j].attr === 'event') {
              // 需要选内容的
              //              if (
              //                item.terms[j].selectedOptions[2].split('@')[0] === 'click_menu' ||
              //                item.terms[j].selectedOptions[2].split('@')[0] === 'click_page_link' ||
              //                item.terms[j].selectedOptions[2].split('@')[0] === 'form_data' ||
              //                item.terms[j].selectedOptions[2].split('@')[0] === 'forward_to_wechat' ||
              //                item.terms[j].selectedOptions[2].split('@')[0] === 'leaving_message' ||
              //                item.terms[j].selectedOptions[2].split('@')[0] === 'send_tpl_message' ||
              //                item.terms[j].selectedOptions[2].split('@')[0] === 'red_packet' ||
              //                item.terms[j].selectedOptions[2].split('@')[0] === 'submit_form' ||
              //                item.terms[j].selectedOptions[2].split('@')[0] === 'subscribe' ||
              //                item.terms[j].selectedOptions[2].split('@')[0] === 'unsubscribe' ||
              //                item.terms[j].selectedOptions[2].split('@')[0] === 'view_page' ||
              //                item.terms[j].selectedOptions[2].split('@')[0] === 'wechat_goods_exchange' ||
              //                item.terms[j].selectedOptions[2].split('@')[0] === 'scan_qrcode' ||
              //                item.terms[j].selectedOptions[2].split('@')[0] === 'scan_offline_qrcode' ||
              //                item.terms[j].selectedOptions[2].split('@')[0] === 'forward_to_we_friend'
              //              ) {
              //                if (item.terms[j].value === '') {
              //                  _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '      值不能为空')
              //                  return
              //                }
              //              }
              // 如果是微信回复
              if (item.terms[j].selectedOptions[2].split('@')[0] === 'public_to_reply') {
                if (item.terms[j].value === '') {
                  _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     微信公众号不能为空')
                  return
                }
                if (item.terms[j].public_reply_type_all.reply_type === null || item.terms[j].public_reply_type_all.reply_type === '') {
                  _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     微信回复类型不能为空')
                  return
                }
              }
              // 限制属性
              if (item.terms[j].eventLimitAttr === true) {
                console.log('102')
                if (item.terms[j].selectedOptions[1] !== 'order') {
                  for (let yi of item.terms[j].eventAttrOptions) {
                    if (yi.attributeContent === '') {
                      _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性名称不能为空')
                      return
                    }
                    if (yi.attributeRelation === '') {
                      _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性相对关系不能为空')
                      return
                    }
                    if (yi.attributeRelation !== 'empty' && yi.attributeRelation !== 'not_empty') {
                      if (yi.attributeValue === '') {
                        _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性值不能为空')
                        return
                      }
                    }
                  }
                }
                if (item.terms[j].selectedOptions[1] === 'order') {
                  for (let yi of item.terms[j].eventAttrOptions) {
                    if (yi.attributeContent.length === 0) {
                      _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性名称不能为空')
                      return
                    }
                    if (yi.attributeRelation === '') {
                      _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性相对关系不能为空')
                      return
                    }
                    if (yi.attributeRelation !== 'empty' && yi.attributeRelation !== 'not_empty' && yi.attributeRelation !== 'gtele') {
                      if (yi.attributeValue === '') {
                        _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性值不能为空')
                        return
                      }
                    }
                    if (yi.attributeRelation === 'gtele') {
                      if (yi.attrValTimeStart === '') {
                        _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性下单时间起始值不能为空')
                        return
                      }
                      if (yi.attrValTimeEnd === '') {
                        _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性下单时间结束值不能为空')
                        return
                      }
                    }
                  }
                }
              }
              // 限制起止时间
              if (item.terms[j].eventLimitTime === true) {
                if (item.terms[j].eventDateStart === '' || item.terms[j].eventDateEnd === '') {
                  _g.toastMsg('error', '请选择起止时间')
                  return
                }
              }
              // 限制发生次数
              if (item.terms[j].eventCheckbox2 === true) {
                if (item.terms[j].eventSearchTimesSelect === '') {
                  _g.toastMsg('error', '请选择发生次数相对关系')
                  return
                }
                if (item.terms[j].eventSearchTimesSelect !== 'gtele') {
                  if (item.terms[j].happenedTimes === '') {
                    _g.toastMsg('error', '发生次数不能为空')
                    return
                  }
                }
                if (item.terms[j].eventSearchTimesSelect === 'gtele') {
                  if (item.terms[j].happenedTimes_from === '' || item.terms[j].happenedTimes_to === '') {
                    _g.toastMsg('error', '发生次数区间值不能为空')
                    return
                  }
                }
              }
            }
            // 判断关注公众号是否为空
            if (item.terms[j].attr === 'follow_public') {
              if (item.terms[j].value === '' || item.terms[j].value === null) {
                _g.toastMsg('error', '关注公众号-' + item.terms[j].attr_label + '      值不能为空')
                return
              }
            }
            // 判断客户身份是否为空
            if (item.terms[j].attr === 'customer_identity') {
              if (item.terms[j].relationship === '') {
                _g.toastMsg('error', '请选择相对关系')
                return
              }
              if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not empty') {
                if (item.terms[j].value === '' || item.terms[j].value === null) {
                  _g.toastMsg('error', '客户身份-' + item.terms[j].attr_label + '      值不能为空')
                  return
                }
              }
            }
            // 判断关客户关键指标是否为空
            if (item.terms[j].attr === 'customer_kpi') {
              if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not empty') {
                if (item.terms[j].relationship === '') {
                  _g.toastMsg('error', '请选择相对关系')
                  return
                }
                if (item.terms[j].relationship !== 'gtele') {
                  if (item.terms[j].value === '' || item.terms[j].value === null || typeof item.terms[j].value === 'undefined') {
                    _g.toastMsg('error', '客户关键指标-' + item.terms[j].attr_label + '      值不能为空')
                    return
                  }
                }
                if (item.terms[j].relationship === 'gtele') {
                  if (typeof item.terms[j].minKpiValue === 'undefined' || typeof item.terms[j].maxKpiValue === 'undefined' || item.terms[j].minKpiValue === '' || item.terms[j].maxKpiValue === null || item.terms[j].maxKpiValue === '' || item.terms[j].minKpiValue === null) {
                    _g.toastMsg('error', '客户关键指标-' + item.terms[j].attr_label + '      区间值不能为空')
                    return
                  }
                }
              }
            }
          }
        }
      }
      this.isShow = false
      let termsSend = JSON.parse(JSON.stringify(this.allTerms))
      for (let item of termsSend.termsGroup) {
        for (let one of item.terms) {
          let str = ''
          if (one.selectedOptions[0] === 'event') {
            str = one.selectedOptions[2].split('@')
          } else {
            str = one.selectedOptions[1].split('@')
          }
          let firAttr = one.selectedOptions[0]
          one.attr = firAttr
          one.secAttr = str[0]
          one.option = null
          one.relationOptions = null
          one.optionOther = null
          one.qrcodeOptions = null
          one.templateOption = null
        }
      }
      getCustomerList(1, 0, termsSend).then((res) => {
        if (res.data.code === 0) {
          this.page = 1
          let data = res.data.data.list
          this.result = []
          for (let i = 0; i < data.length; i += 10) {
            this.result.push(data.slice(i, i + 10))
          }
          // 计算总体请求数据的长度
          this.len = 0
          for (let item of this.result) {
            this.len = this.len + item.length
          }
          this.searchData = this.result[0]
          this.totalCount = res.data.data.count
        }
      })
    },
    // 关闭高级查询
    closeHigherSearch() {
      this.isHigher = false
      this.page = 1
      this.isShow = true
      this.searchData = []
      this.result = []
      this.lastId = 0
      this.load()
      this.forSonTerms = [
        {
          inOperator: 'and',
          terms: [
            {
              attr: 'attr',
              attr_label: '真实姓名',
              relationship: '',
              relationOptions: [
                {
                  value: '=',
                  label: '等于'
                }, {
                  value: '!=',
                  label: '不等于'
                }, {
                  value: 'contain',
                  label: '包含'
                }, {
                  value: 'empty',
                  label: '为空'
                },
                {
                  value: 'not empty',
                  label: '不为空'
                }
              ],
              value: null,
              original_id: null,
              eventAttributeList: [],
              activitiesTwo: [],
              templatesTwo: [],
              wepageTwo: [],
              eventAttrOptions: [
                {
                  attributeContent: '',
                  relationOptions: [],
                  sources: [],
                  eventAttrValueOptions: [],
                  attributeRelation: '',
                  attr_type: '',
                  attrValTimeStart: '',
                  attrValTimeEnd: '',
                  attributeValueStart: '',
                  attributeValueEnd: '',
                  attributeValue: ''
                }
              ],
              optionOther: null,
              qrcodeOptions: null,
              templateOption: null,
              qrcode: null,
              offline_qrcode: null,
              template_id: null,
              leave_word: null,
              public_reply_type_all: {
                reply_type: '不限',
                reply_content: ''
              },
              eventLimitTime: false,
              eventLimitTimes: false,
              eventLimitAttr: false,
              eventTimeRelation: '',
              eventDateStart: '',
              eventDateEnd: '',
              happenedTimes: '',
              start_time: '',
              end_time: '',
              selectedOptions: ['attr', 'realname@input']
            }
          ]
        }
      ]
    },
    // 保存查询条件
    saveThis() {
      // 判断是否为空
      for (let i in this.allTerms.termsGroup) {
        let item = this.allTerms.termsGroup[i]
        for (let j in item.terms) {
          if (item.terms[j].selectedOptions[0] === 'attr') {
            if (item.terms[j].relationship === '') {
              _g.toastMsg('error', '请选择相对关系')
              return
            }
          }
          // 判断客户属性是否为空
          if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not empty') {
            if (item.terms[j].attr === 'attr') {
              // 判断是否是时间且为区间
              if (item.terms[j].selectedOptions[1].split('@')[1] === 'datePicker' || item.terms[j].selectedOptions[1].split('@')[1] === 'dateTimePicker') {
                if (item.terms[j].relationship === 'gtele') {
                  if (item.terms[j].start_time === '') {
                    _g.toastMsg('error', '客户属性-' + item.terms[j].attr_label + '      起始时间值不能为空')
                    return
                  }
                  if (item.terms[j].end_time === '') {
                    _g.toastMsg('error', '客户属性-' + item.terms[j].attr_label + '      结束时间值不能为空')
                    return
                  }
                } else if (item.terms[j].value === '' || item.terms[j].value === null || item.terms[j].value.length === 0) {
                  _g.toastMsg('error', '客户属性-' + item.terms[j].attr_label + '      值不能为空')
                  return
                }
              } else if (item.terms[j].value === '' || item.terms[j].value === null || item.terms[j].value.length === 0) {
                _g.toastMsg('error', '客户属性-' + item.terms[j].attr_label + '      值不能为空')
                return
              }
            }
          }
          // 判断群组是否为空
          if (item.terms[j].attr === 'group') {
            if (item.terms[j].value === '' || item.terms[j].value === null) {
              _g.toastMsg('error', '群组-' + item.terms[j].attr_label + '      值不能为空')
              return
            }
          }
          // 判断客户事件是否为空
          if (item.terms[j].attr === 'event') {
            // 需要选内容的
            //              if (
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'click_menu' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'click_page_link' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'form_data' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'forward_to_wechat' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'leaving_message' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'send_tpl_message' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'red_packet' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'submit_form' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'subscribe' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'unsubscribe' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'view_page' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'wechat_goods_exchange' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'scan_qrcode' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'scan_offline_qrcode' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'forward_to_we_friend'
            //              ) {
            //                if (item.terms[j].value === '') {
            //                  _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '      值不能为空')
            //                  return
            //                }
            //              }
            // 如果是微信回复
            if (item.terms[j].selectedOptions[2].split('@')[0] === 'public_to_reply') {
              if (item.terms[j].value === '') {
                _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     微信公众号不能为空')
                return
              }
              if (item.terms[j].public_reply_type_all.reply_type === null || item.terms[j].public_reply_type_all.reply_type === '') {
                _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     微信回复类型不能为空')
                return
              }
            }
            // 限制属性
            if (item.terms[j].eventLimitAttr === true) {
              console.log('102')
              if (item.terms[j].selectedOptions[1] !== 'order') {
                for (let yi of item.terms[j].eventAttrOptions) {
                  if (yi.attributeContent === '') {
                    _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性名称不能为空')
                    return
                  }
                  if (yi.attributeRelation === '') {
                    _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性相对关系不能为空')
                    return
                  }
                  if (yi.attributeRelation !== 'empty' && yi.attributeRelation !== 'not_empty') {
                    if (yi.attributeValue === '') {
                      _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性值不能为空')
                      return
                    }
                  }
                }
              }
              if (item.terms[j].selectedOptions[1] === 'order') {
                for (let yi of item.terms[j].eventAttrOptions) {
                  if (yi.attributeContent.length === 0) {
                    _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性名称不能为空')
                    return
                  }
                  if (yi.attributeRelation === '') {
                    _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性相对关系不能为空')
                    return
                  }
                  if (yi.attributeRelation !== 'empty' && yi.attributeRelation !== 'not_empty' && yi.attributeRelation !== 'gtele') {
                    if (yi.attributeValue === '') {
                      _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性值不能为空')
                      return
                    }
                  }
                  if (yi.attributeRelation === 'gtele') {
                    if (yi.attrValTimeStart === '') {
                      _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性下单时间起始值不能为空')
                      return
                    }
                    if (yi.attrValTimeEnd === '') {
                      _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性下单时间结束值不能为空')
                      return
                    }
                  }
                }
              }
            }
            // 限制起止时间
            if (item.terms[j].eventLimitTime === true) {
              if (item.terms[j].eventDateStart === '' || item.terms[j].eventDateEnd === '') {
                _g.toastMsg('error', '请选择起止时间')
                return
              }
            }
            // 限制发生次数
            if (item.terms[j].eventCheckbox2 === true) {
              if (item.terms[j].eventSearchTimesSelect === '') {
                _g.toastMsg('error', '请选择发生次数相对关系')
                return
              }
              if (item.terms[j].eventSearchTimesSelect !== 'gtele') {
                if (item.terms[j].happenedTimes === '') {
                  _g.toastMsg('error', '发生次数不能为空')
                  return
                }
              }
              if (item.terms[j].eventSearchTimesSelect === 'gtele') {
                if (item.terms[j].happenedTimes_from === '' || item.terms[j].happenedTimes_to === '') {
                  _g.toastMsg('error', '发生次数区间值不能为空')
                  return
                }
              }
            }
          }
          // 判断关注公众号是否为空
          if (item.terms[j].attr === 'follow_public') {
            if (item.terms[j].value === '' || item.terms[j].value === null) {
              _g.toastMsg('error', '关注公众号-' + item.terms[j].attr_label + '      值不能为空')
              return
            }
          }
          // 判断客户身份是否为空
          if (item.terms[j].attr === 'customer_identity') {
            if (item.terms[j].relationship === '') {
              _g.toastMsg('error', '请选择相对关系')
              return
            }
            if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not empty') {
              if (item.terms[j].value === '' || item.terms[j].value === null) {
                _g.toastMsg('error', '客户身份-' + item.terms[j].attr_label + '      值不能为空')
                return
              }
            }
          }
          // 判断关客户关键指标是否为空
          if (item.terms[j].attr === 'customer_kpi') {
            if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not empty') {
              if (item.terms[j].relationship === '') {
                _g.toastMsg('error', '请选择相对关系')
                return
              }
              if (item.terms[j].relationship !== 'gtele') {
                if (item.terms[j].value === '' || item.terms[j].value === null || typeof item.terms[j].value === 'undefined') {
                  _g.toastMsg('error', '客户关键指标-' + item.terms[j].attr_label + '      值不能为空')
                  return
                }
              }
              if (item.terms[j].relationship === 'gtele') {
                if (typeof item.terms[j].minKpiValue === 'undefined' || typeof item.terms[j].maxKpiValue === 'undefined' || item.terms[j].minKpiValue === '' || item.terms[j].maxKpiValue === null || item.terms[j].maxKpiValue === '' || item.terms[j].minKpiValue === null) {
                  _g.toastMsg('error', '客户关键指标-' + item.terms[j].attr_label + '      区间值不能为空')
                  return
                }
              }
            }
          }
        }
      }
      if (this.saveType === 1) {
        let termsSend = JSON.parse(JSON.stringify(this.allTerms))
        for (let item of termsSend.termsGroup) {
          for (let one of item.terms) {
            let str = ''
            if (one.selectedOptions[0] === 'event') {
              str = one.selectedOptions[2].split('@')
            } else {
              str = one.selectedOptions[1].split('@')
            }
            let firAttr = one.selectedOptions[0]
            one.attr = firAttr
            one.secAttr = str[0]
            one.option = null
            one.relationOptions = null
          }
        }
        // 防止重复点击
        this.isDisabled = true
        let id = this.$route.query.id
        editGroupManageDetail(termsSend, id).then((res) => {
          if (res.data.code === 0) {
            this.isDisabled = false
            this.isHigher = false
            this.isShow = true
            this.searchData = []
            this.load()
            _g.toastMsg('success', '修改群组成功,群组的变更需要一段时间,请稍后刷新')
          } else {
            this.isDisabled = false
            _g.toastMsg('error', res.data.error)
          }
        })
      } else if (this.saveType === 2) {
        let termsSend = JSON.parse(JSON.stringify(this.allTerms))
        for (let item of termsSend.termsGroup) {
          for (let one of item.terms) {
            let str = ''
            if (one.selectedOptions[0] === 'event') {
              str = one.selectedOptions[2].split('@')
            } else {
              str = one.selectedOptions[1].split('@')
            }
            let firAttr = one.selectedOptions[0]
            one.attr = firAttr
            one.secAttr = str[0]
          }
        }
        // 防止重复点击
        this.isDisabled = true
        let id = this.$route.query.id
        addGroupManageDetail(termsSend, id).then((res) => {
          if (res.data.code === 0) {
            this.isDisabled = false
            this.isHigher = false
            this.isShow = true
            this.searchData = []
            this.load()
            _g.toastMsg('success', '添加客户成功,群组的变更需要一段时间,请稍后刷新')
          } else {
            this.isDisabled = false
            _g.toastMsg('error', res.data.error)
          }
        })
      }
    },
    // 点击编辑打开高级查询
    edit() {
      this.isHigher = true
      this.saveType = 1
      this.result = []
      this.lastId = 0
    },
    // 静态点击添加客户出现高级查询
    addNewCustomer() {
      this.isHigher = true
      this.saveType = 2
      this.result = []
      this.lastId = 0
    },
    // 获取子组件的查询条件
    getAllTerms(value) {
      this.allTerms = value
    },
    // 计算刷新客户数据（智能数组页面）
    refreshCustomer() {
      let id = this.$route.query.id
      this.query.number = -1
      refreshCustomer(id).then((res) => {
        if (res.data.code === 0) {
          _g.toastMsg('success', res.data.error)
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
      // 轮询number
      let _this = this
      let timer = setInterval(function () {
        getGroupDetail(id, 1, this.search, this.lastId).then((res) => {
          if (res.data.data.query.number > -1) {
            _this.tableData = res.data.data.customer_list
            _this.customerCount = res.data.data.count
            _this.query = res.data.data.query
            _this.allTerms = res.data.data.condition
            clearInterval(timer)
          }
        })
      }, 5000)
    },
    // 获取客户属性
    getCustomerAttributes() {
      getCustomerAttributeList().then((res) => {
        if (res.data.code === 0) {
          this.identities = res.data.data
        }
      })
    },
    downloadFiles() {
      if (this.customerCount === 0) {
        _g.toastMsg('error', '没有数据可导出')
        return
      }
      let type = parseInt(this.$route.query.type)
      console.log('000', type)
      let search = {}
      if (type === 1) {
        // 开始传导出的查询参数
        if (this.downloadUse === 0) {
          let aaa = JSON.parse(JSON.stringify(this.downloadSearch))
          for (let item of aaa.termsGroup) {
            for (let one of item.terms) {
              let str = ''
              if (one.selectedOptions[0] === 'event') {
                str = one.selectedOptions[2].split('@')
              } else {
                str = one.selectedOptions[1].split('@')
              }
              let firAttr = one.selectedOptions[0]
              one.attr = firAttr
              one.secAttr = str[0]
              one.option = null
              one.relationOptions = null
              one.optionOther = null
              one.qrcodeOptions = null
              one.templateOption = null
            }
          }
          search = aaa
        }
        if (this.downloadUse === 1) {
          let bbb = JSON.parse(JSON.stringify(this.downloadSearch))
          bbb.termsGroup.push({
            inOperator: 'and',
            terms: [
              {
                attr: 'attr',
                relationship: 'gtele',
                attr_label: '创建时间',
                relationOptions: [
                  {
                    value: '=',
                    label: '等于'
                  }, {
                    value: '!=',
                    label: '不等于'
                  }, {
                    value: 'contain',
                    label: '包含'
                  }, {
                    value: 'empty',
                    label: '为空'
                  },
                  {
                    value: 'not empty',
                    label: '不为空'
                  }
                ],
                value: null,
                original_id: null,
                eventAttributeList: [],
                activitiesTwo: [],
                templatesTwo: [],
                wepageTwo: [],
                eventAttrOptions: [
                  {
                    attributeContent: '',
                    relationOptions: [],
                    sources: [],
                    eventAttrValueOptions: [],
                    attributeRelation: '',
                    attr_type: '',
                    attrValTimeStart: '',
                    attrValTimeEnd: '',
                    attributeValueStart: '',
                    attributeValueEnd: '',
                    attributeValue: ''
                  }
                ],
                optionOther: null,
                qrcodeOptions: null,
                templateOption: null,
                qrcode: null,
                offline_qrcode: null,
                template_id: null,
                leave_word: null,
                public_reply_type_all: {
                  reply_type: '不限',
                  reply_content: ''
                },
                eventLimitTime: false,
                eventLimitTimes: false,
                eventLimitAttr: false,
                eventTimeRelation: '',
                eventDateStart: '',
                eventDateEnd: '',
                happenedTimes: '',
                start_time: this.search.start_time,
                end_time: this.search.end_time,
                secAttr: 'create_time',
                selectedOptions: ['attr', 'create_time@datePicker']
              }
            ]
          })
          for (let item of bbb.termsGroup) {
            for (let one of item.terms) {
              let str = ''
              if (one.selectedOptions[0] === 'event') {
                str = one.selectedOptions[2].split('@')
              } else {
                str = one.selectedOptions[1].split('@')
              }
              let firAttr = one.selectedOptions[0]
              one.attr = firAttr
              one.secAttr = str[0]
              one.option = null
              one.relationOptions = null
              one.optionOther = null
              one.qrcodeOptions = null
              one.templateOption = null
            }
          }
          search = bbb
        }
        if (this.downloadUse === 2) {
          for (let item of this.allTerms.termsGroup) {
            for (let one of item.terms) {
              let str = ''
              if (one.selectedOptions[0] === 'event') {
                str = one.selectedOptions[2].split('@')
              } else {
                str = one.selectedOptions[1].split('@')
              }
              let firAttr = one.selectedOptions[0]
              one.attr = firAttr
              one.secAttr = str[0]
              one.option = null
              one.relationOptions = null
              one.optionOther = null
              one.qrcodeOptions = null
              one.templateOption = null
            }
          }
          search = this.allTerms
        }
      }
      if (type === 2) {
        console.log('---', this.downloadUse)
        // 上来就导出
        if (this.downloadUse === 0) {
          console.log('122121', type)
          let id = this.$route.query.id
          let ccc = {
            allRelationship: 'and',
            termsGroup: [
              {
                inOperator: 'and',
                terms: [
                  {
                    attr: 'group',
                    relationship: '=',
                    attr_label: '群组',
                    relationOptions: [
                      {
                        value: '=',
                        label: '等于'
                      }, {
                        value: '!=',
                        label: '不等于'
                      }, {
                        value: 'contain',
                        label: '包含'
                      }, {
                        value: 'empty',
                        label: '为空'
                      },
                      {
                        value: 'not empty',
                        label: '不为空'
                      }
                    ],
                    value: id,
                    original_id: null,
                    eventAttributeList: [],
                    activitiesTwo: [],
                    templatesTwo: [],
                    wepageTwo: [],
                    eventAttrOptions: [
                      {
                        attributeContent: '',
                        relationOptions: [],
                        sources: [],
                        eventAttrValueOptions: [],
                        attributeRelation: '',
                        attr_type: '',
                        attrValTimeStart: '',
                        attrValTimeEnd: '',
                        attributeValueStart: '',
                        attributeValueEnd: '',
                        attributeValue: ''
                      }
                    ],
                    optionOther: null,
                    qrcodeOptions: null,
                    templateOption: null,
                    qrcode: null,
                    offline_qrcode: null,
                    template_id: null,
                    leave_word: null,
                    public_reply_type_all: {
                      reply_type: '不限',
                      reply_content: ''
                    },
                    eventLimitTime: false,
                    eventLimitTimes: false,
                    eventLimitAttr: false,
                    eventTimeRelation: '',
                    eventDateStart: '',
                    eventDateEnd: '',
                    happenedTimes: '',
                    start_time: '',
                    end_time: '',
                    secAttr: 'inGroup',
                    selectedOptions: ['group', 'inGroup@select']
                  }
                ]
              }
            ]
          }
          for (let item of ccc.termsGroup) {
            for (let one of item.terms) {
              let str = ''
              if (one.selectedOptions[0] === 'event') {
                str = one.selectedOptions[2].split('@')
              } else {
                str = one.selectedOptions[1].split('@')
              }
              let firAttr = one.selectedOptions[0]
              one.attr = firAttr
              one.secAttr = str[0]
              one.option = null
              one.relationOptions = null
              one.optionOther = null
              one.qrcodeOptions = null
              one.templateOption = null
            }
          }
          search = ccc
          console.log('122121', search)
        }
        // 初级查询导出
        if (this.downloadUse === 1) {
          console.log('122121', type)
          let id = this.$route.query.id
          let ddd = {
            allRelationship: 'and',
            termsGroup: [
              {
                inOperator: 'and',
                terms: [
                  {
                    attr: 'group',
                    relationship: '=',
                    attr_label: '群组',
                    relationOptions: [
                      {
                        value: '=',
                        label: '等于'
                      }, {
                        value: '!=',
                        label: '不等于'
                      }, {
                        value: 'contain',
                        label: '包含'
                      }, {
                        value: 'empty',
                        label: '为空'
                      },
                      {
                        value: 'not empty',
                        label: '不为空'
                      }
                    ],
                    value: id,
                    original_id: null,
                    eventAttributeList: [],
                    activitiesTwo: [],
                    templatesTwo: [],
                    wepageTwo: [],
                    eventAttrOptions: [
                      {
                        attributeContent: '',
                        relationOptions: [],
                        sources: [],
                        eventAttrValueOptions: [],
                        attributeRelation: '',
                        attr_type: '',
                        attrValTimeStart: '',
                        attrValTimeEnd: '',
                        attributeValueStart: '',
                        attributeValueEnd: '',
                        attributeValue: ''
                      }
                    ],
                    optionOther: null,
                    qrcodeOptions: null,
                    templateOption: null,
                    qrcode: null,
                    offline_qrcode: null,
                    template_id: null,
                    leave_word: null,
                    public_reply_type_all: {
                      reply_type: '不限',
                      reply_content: ''
                    },
                    eventLimitTime: false,
                    eventLimitTimes: false,
                    eventLimitAttr: false,
                    eventTimeRelation: '',
                    eventDateStart: '',
                    eventDateEnd: '',
                    happenedTimes: '',
                    start_time: '',
                    end_time: '',
                    secAttr: 'inGroup',
                    selectedOptions: ['group', 'inGroup@select']
                  },
                  {
                    attr: 'attr',
                    relationship: 'gtele',
                    attr_label: '创建时间',
                    relationOptions: [
                      {
                        value: '=',
                        label: '等于'
                      }, {
                        value: '!=',
                        label: '不等于'
                      }, {
                        value: 'contain',
                        label: '包含'
                      }, {
                        value: 'empty',
                        label: '为空'
                      },
                      {
                        value: 'not empty',
                        label: '不为空'
                      }
                    ],
                    value: null,
                    original_id: null,
                    eventAttributeList: [],
                    activitiesTwo: [],
                    templatesTwo: [],
                    wepageTwo: [],
                    eventAttrOptions: [
                      {
                        attributeContent: '',
                        relationOptions: [],
                        sources: [],
                        eventAttrValueOptions: [],
                        attributeRelation: '',
                        attr_type: '',
                        attrValTimeStart: '',
                        attrValTimeEnd: '',
                        attributeValueStart: '',
                        attributeValueEnd: '',
                        attributeValue: ''
                      }
                    ],
                    optionOther: null,
                    qrcodeOptions: null,
                    templateOption: null,
                    qrcode: null,
                    offline_qrcode: null,
                    template_id: null,
                    leave_word: null,
                    public_reply_type_all: {
                      reply_type: '不限',
                      reply_content: ''
                    },
                    eventLimitTime: false,
                    eventLimitTimes: false,
                    eventLimitAttr: false,
                    eventTimeRelation: '',
                    eventDateStart: '',
                    eventDateEnd: '',
                    happenedTimes: '',
                    start_time: this.search.start_time,
                    end_time: this.search.end_time,
                    secAttr: 'create_time',
                    selectedOptions: ['attr', 'create_time@datePicker']
                  }
                ]
              }
            ]
          }
          for (let item of ddd.termsGroup) {
            for (let one of item.terms) {
              let str = ''
              if (one.selectedOptions[0] === 'event') {
                str = one.selectedOptions[2].split('@')
              } else {
                str = one.selectedOptions[1].split('@')
              }
              let firAttr = one.selectedOptions[0]
              one.attr = firAttr
              one.secAttr = str[0]
              one.option = null
              one.relationOptions = null
              one.optionOther = null
              one.qrcodeOptions = null
              one.templateOption = null
            }
          }
          search = ddd
          console.log('122121', search)
        }
        // 高级查询导出
        if (this.downloadUse === 2) {
          for (let item of this.allTerms.termsGroup) {
            for (let one of item.terms) {
              let str = ''
              if (one.selectedOptions[0] === 'event') {
                str = one.selectedOptions[2].split('@')
              } else {
                str = one.selectedOptions[1].split('@')
              }
              let firAttr = one.selectedOptions[0]
              one.attr = firAttr
              one.secAttr = str[0]
              one.option = null
              one.relationOptions = null
              one.optionOther = null
              one.qrcodeOptions = null
              one.templateOption = null
            }
          }
          search = this.allTerms
        }
      }
      let gold = {}
      // 属性集合
      for (let item of this.identities) {
        gold[item.identity] = item.name
      }
      exportCustomer(search, gold).then(response => {
        // this.download(response)
        _g.toastMsg('href', '')
      }).catch((error) => {
        console.log(error)
        _g.toastMsg('error', error)
      })
    },
    // 下载文件
    download (data) {
      if (!data) {
        return
      }
      var now = new Date()
      var year = now.getFullYear()
      var month = (now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth()) + 1)
      var date = now.getDate()
      var hour = now.getHours()
      var minute = now.getMinutes()
      var second = now.getSeconds()
      let time = ''
      time = year + '' + month + '' + date + '' + hour + '' + minute + '' + second
      var blob = new Blob([data.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }) // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
      var downloadElement = document.createElement('a')
      var href = window.URL.createObjectURL(blob) // 创建下载的链接
      downloadElement.href = href
      downloadElement.download = time + '.xlsx' // 下载后文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() // 点击下载
      document.body.removeChild(downloadElement) // 下载完成移除元素
      window.URL.revokeObjectURL(href) // 释放掉blob对象
    },
    // 处理分页
    handleSizeChange(val) {
      this.limit = val
      if (this.isHigher === false) {
        this.lastId = this.tableData[this.tableData.length - 1].id
        this.load()
      } else {
        this.lastId = this.searchData[this.tableData.length - 1].id
        this.preView()
      }
    },
    handleCurrentChange(page) {
      this.page = page
      if (this.isHigher === false) {
        this.tableData = this.result[page - 1]
        let id = this.$route.query.id
        this.lastId = this.tableData[this.tableData.length - 1].id
        if (this.result[this.result.length - 1].length === 10) {
          if (this.lastId === this.result[this.result.length - 1][9].id) {
            getGroupDetail(id, this.page, this.search, this.lastId).then((res) => {
              if (res.data.code === 0) {
                let data = res.data.data.customer_list
                for (let i = 0; i < data.length; i += 10) {
                  this.result.push(data.slice(i, i + 10))
                }
                // 计算总体请求数据的长度
                this.len = 0
                for (let item of this.result) {
                  this.len = this.len + item.length
                }
                this.tableData = this.result[page - 1]
                this.totalCount = res.data.data.count
              }
            })
          }
        }
      } else {
        this.searchData = this.result[page - 1]
        this.lastId = this.searchData[this.searchData.length - 1].id
        if (this.lastId === this.result[this.result.length - 1][9].id) {
          let termsSend = JSON.parse(JSON.stringify(this.allTerms))
          for (let item of termsSend.termsGroup) {
            for (let one of item.terms) {
              let str = ''
              if (one.selectedOptions[0] === 'event') {
                str = one.selectedOptions[2].split('@')
              } else {
                str = one.selectedOptions[1].split('@')
              }
              let firAttr = one.selectedOptions[0]
              one.attr = firAttr
              one.secAttr = str[0]
              one.option = null
              one.relationOptions = null
              one.optionOther = null
              one.qrcodeOptions = null
              one.templateOption = null
            }
          }
          getCustomerList(this.page, this.lastId, termsSend).then((res) => {
            if (res.data.code === 0) {
              let data = res.data.data.list
              for (let i = 0; i < data.length; i += 10) {
                this.result.push(data.slice(i, i + 10))
              }
              // 计算总体请求数据的长度
              this.len = 0
              for (let item of this.result) {
                this.len = this.len + item.length
              }
              this.searchData = this.result[page - 1]
              this.totalCount = res.data.data.count
            }
          })
        }
      }
    },
    // 加载群组列表
    load() {
      let id = this.$route.query.id
      let type = this.$route.query.type
      this.type = parseInt(type)
      this.isShow = true
      if (this.timeaa === null) {
        this.search.start_time = ''
        this.search.end_time = ''
      } else {
        this.search.start_time = this.timeaa[0]
        this.search.end_time = this.timeaa[1]
      }
      getGroupDetail(id, 1, this.search, 0).then((res) => {
        if (res.data.code === 0) {
          this.result = []
          let data = res.data.data.customer_list
          for (let i = 0; i < data.length; i += 10) {
            this.result.push(data.slice(i, i + 10))
          }
          // 计算总体请求数据的长度
          this.len = 0
          for (let item of this.result) {
            this.len = this.len + item.length
          }
          this.tableData = this.result[0]
          this.totalCount = res.data.data.result_count
          this.customerCount = res.data.data.count
          this.query = res.data.data.query
          this.downloadSearch = res.data.data.query.query
          console.log('520', this.type)
          if (this.type === 1) {
            let terms = res.data.data.query.query.termsGroup
            console.log('502')
            for (let one of terms) {
              for (let item of one.terms) {
                // 回显属性
                if (item.selectedOptions[0] === 'attr') {
                  // 回显客户等级与来源
                  if (item.selectedOptions[1].split('@')[0] === 'source_id') {
                    getSourceData().then((res) => {
                      item.option = res.data.data.list
                    })
                  }
                  if (item.selectedOptions[1].split('@')[0] === 'stage_id') {
                    getCustomerStage().then((res) => {
                      item.option = res.data.data
                      item.option.unshift({
                        name: '未知等级',
                        id: 0
                      })
                    })
                  }
                  /* -------------自定义属性的相对关系------------ */
                  // 文本
                  if (item.selectedOptions[1].split('@')[1] === 'input') {
                    item.relationOptions = [
                      {
                        value: '=',
                        label: '等于'
                      }, {
                        value: 'contain',
                        label: '包含'
                      }, {
                        value: 'empty',
                        label: '为空'
                      },
                      {
                        value: 'not empty',
                        label: '不为空'
                      }
                    ]
                  }
                  // 下拉
                  if (item.selectedOptions[1].split('@')[1] === 'select') {
                    item.relationOptions = [
                      {
                        value: '=',
                        label: '等于'
                      }, {
                        value: '!=',
                        label: '不等于'
                      }, {
                        value: 'empty',
                        label: '为空'
                      },
                      {
                        value: 'not empty',
                        label: '不为空'
                      }
                    ]
                  }
                  // 日期
                  if (item.selectedOptions[1].split('@')[1] === 'datePicker') {
                    item.relationOptions = [
                      {
                        value: 'gt',
                        label: '晚于'
                      }, {
                        value: '=',
                        label: '等于'
                      }, {
                        value: 'lt',
                        label: '早于'
                      }, {
                        value: 'gtele',
                        label: '区间'
                      }, {
                        value: 'empty',
                        label: '为空'
                      },
                      {
                        value: 'not empty',
                        label: '不为空'
                      }
                    ]
                  }
                  // 位置
                  if (item.selectedOptions[1].split('@')[1] === 'addressPicker') {
                    item.relationOptions = [
                      {
                        value: '=',
                        label: '等于'
                      }, {
                        value: '!=',
                        label: '不等于'
                      }, {
                        value: 'empty',
                        label: '为空'
                      },
                      {
                        value: 'not empty',
                        label: '不为空'
                      }
                    ]
                  }
                  // 单选
                  if (item.selectedOptions[1].split('@')[1] === 'radio') {
                    item.relationOptions = [
                      {
                        value: '=',
                        label: '等于'
                      }, {
                        value: 'empty',
                        label: '为空'
                      },
                      {
                        value: 'not empty',
                        label: '不为空'
                      }
                    ]
                  }
                  // 复选
                  if (item.selectedOptions[1].split('@')[1] === 'checkBox') {
                    item.relationOptions = [
                      {
                        value: '=',
                        label: '等于'
                      }, {
                        value: 'empty',
                        label: '为空'
                      },
                      {
                        value: 'not empty',
                        label: '不为空'
                      }
                    ]
                  }
                  /* -------------系统属性的相对关系------------ */
                  // 真实姓名
                  if (item.selectedOptions[1].split('@')[0] === 'realname' && item.selectedOptions[1].split('@')[1] === 'input') {
                    console.log('502')
                    item.relationOptions = [
                      {
                        value: '=',
                        label: '等于'
                      }, {
                        value: '!=',
                        label: '不等于'
                      }, {
                        value: 'contain',
                        label: '包含'
                      }, {
                        value: 'empty',
                        label: '为空'
                      },
                      {
                        value: 'not empty',
                        label: '不为空'
                      }
                    ]
                  }
                  // 性别
                  if (item.selectedOptions[1].split('@')[0] === 'sex' && item.selectedOptions[1].split('@')[1] === 'radio') {
                    item.relationOptions = [
                      {
                        value: '=',
                        label: '等于'
                      }, {
                        value: '!=',
                        label: '不等于'
                      }
                    ]
                  }
                  // 当前等级
                  if (item.selectedOptions[1].split('@')[0] === 'stage_id' && item.selectedOptions[1].split('@')[1] === 'radio') {
                    item.relationOptions = [
                      {
                        value: '=',
                        label: '等于'
                      }, {
                        value: '!=',
                        label: '不等于'
                      }
                    ]
                  }
                  // 微信号
                  if (item.selectedOptions[1].split('@')[0] === 'wechat' && item.selectedOptions[1].split('@')[1] === 'input') {
                    item.relationOptions = [
                      {
                        value: '=',
                        label: '等于'
                      }, {
                        value: '!=',
                        label: '不等于'
                      }, {
                        value: 'contain',
                        label: '包含'
                      }, {
                        value: 'empty',
                        label: '为空'
                      },
                      {
                        value: 'not empty',
                        label: '不为空'
                      }
                    ]
                  }
                  // 省市区
                  if (item.selectedOptions[1].split('@')[0] === 'systemPcd' && item.selectedOptions[1].split('@')[1] === 'addressPicker') {
                    item.relationOptions = [
                      {
                        value: '=',
                        label: '等于'
                      }, {
                        value: '!=',
                        label: '不等于'
                      }, {
                        value: 'empty',
                        label: '为空'
                      },
                      {
                        value: 'not empty',
                        label: '不为空'
                      }
                    ]
                  }
                  // 初始来源
                  if (item.selectedOptions[1].split('@')[0] === 'source_id' && item.selectedOptions[1].split('@')[1] === 'radio') {
                    item.relationOptions = [
                      {
                        value: '=',
                        label: '等于'
                      }, {
                        value: '!=',
                        label: '不等于'
                      }, {
                        value: 'empty',
                        label: '为空'
                      },
                      {
                        value: 'not empty',
                        label: '不为空'
                      }
                    ]
                  }
                  // 手机号
                  if (item.selectedOptions[1].split('@')[0] === 'mobile' && item.selectedOptions[1].split('@')[1] === 'input') {
                    item.relationOptions = [
                      {
                        value: '=',
                        label: '等于'
                      }, {
                        value: 'contain',
                        label: '包含'
                      }, {
                        value: 'empty',
                        label: '为空'
                      },
                      {
                        value: 'not empty',
                        label: '不为空'
                      }
                    ]
                  }
                  // 手机号验证
                  if (item.selectedOptions[1].split('@')[0] === 'mobile_verified' && item.selectedOptions[1].split('@')[1] === 'radio') {
                    item.relationOptions = [
                      {
                        value: '=',
                        label: '等于'
                      }
                    ]
                  }
                  // 座机号
                  if (item.selectedOptions[1].split('@')[0] === 'phone' && item.selectedOptions[1].split('@')[1] === 'input') {
                    item.relationOptions = [
                      {
                        value: '=',
                        label: '等于'
                      }, {
                        value: 'contain',
                        label: '包含'
                      }, {
                        value: 'empty',
                        label: '为空'
                      },
                      {
                        value: 'not empty',
                        label: '不为空'
                      }
                    ]
                  }
                  // 邮箱
                  if (item.selectedOptions[1].split('@')[0] === 'email' && item.selectedOptions[1].split('@')[1] === 'input') {
                    item.relationOptions = [
                      {
                        value: '=',
                        label: '等于'
                      }, {
                        value: 'contain',
                        label: '包含'
                      }, {
                        value: 'empty',
                        label: '为空'
                      },
                      {
                        value: 'not empty',
                        label: '不为空'
                      }
                    ]
                  }
                  // 邮箱验证
                  if (item.selectedOptions[1].split('@')[0] === 'email_verified' && item.selectedOptions[1].split('@')[1] === 'radio') {
                    item.relationOptions = [
                      {
                        value: '=',
                        label: '等于'
                      }
                    ]
                  }
                  // 生日
                  if (item.selectedOptions[1].split('@')[0] === 'birthday' && item.selectedOptions[1].split('@')[1] === 'datePicker') {
                    item.relationOptions = [
                      {
                        value: 'gt',
                        label: '晚于'
                      }, {
                        value: '=',
                        label: '等于'
                      }, {
                        value: 'lt',
                        label: '早于'
                      }, {
                        value: 'gtele',
                        label: '区间'
                      }, {
                        value: 'empty',
                        label: '为空'
                      },
                      {
                        value: 'not empty',
                        label: '不为空'
                      }
                    ]
                  }
                  // 家庭住址
                  if (item.selectedOptions[1].split('@')[0] === 'home_address' && item.selectedOptions[1].split('@')[1] === 'input') {
                    item.relationOptions = [
                      {
                        value: 'contain',
                        label: '包含'
                      }, {
                        value: 'empty',
                        label: '为空'
                      },
                      {
                        value: 'not empty',
                        label: '不为空'
                      }
                    ]
                  }
                  // 公司名称
                  if (item.selectedOptions[1].split('@')[0] === 'company' && item.selectedOptions[1].split('@')[1] === 'input') {
                    item.relationOptions = [
                      {
                        value: 'contain',
                        label: '包含'
                      }, {
                        value: 'empty',
                        label: '为空'
                      },
                      {
                        value: 'not empty',
                        label: '不为空'
                      }
                    ]
                  }
                  // 公司地址
                  if (item.selectedOptions[1].split('@')[0] === 'company_address' && item.selectedOptions[1].split('@')[1] === 'input') {
                    item.relationOptions = [
                      {
                        value: 'contain',
                        label: '包含'
                      }, {
                        value: 'empty',
                        label: '为空'
                      },
                      {
                        value: 'not empty',
                        label: '不为空'
                      }
                    ]
                  }
                  // 备注
                  if (item.selectedOptions[1].split('@')[0] === 'remark' && item.selectedOptions[1].split('@')[1] === 'input') {
                    item.relationOptions = [
                      {
                        value: 'contain',
                        label: '包含'
                      }, {
                        value: 'empty',
                        label: '为空'
                      },
                      {
                        value: 'not empty',
                        label: '不为空'
                      }
                    ]
                  }
                  // 行业
                  if (item.selectedOptions[1].split('@')[0] === 'industry' && item.selectedOptions[1].split('@')[1] === 'input') {
                    item.relationOptions = [
                      {
                        value: 'contain',
                        label: '包含'
                      }, {
                        value: 'empty',
                        label: '为空'
                      },
                      {
                        value: 'not empty',
                        label: '不为空'
                      }
                    ]
                  }
                  // 职位
                  if (item.selectedOptions[1].split('@')[0] === 'position' && item.selectedOptions[1].split('@')[1] === 'input') {
                    item.relationOptions = [
                      {
                        value: 'contain',
                        label: '包含'
                      }, {
                        value: 'empty',
                        label: '为空'
                      },
                      {
                        value: 'not empty',
                        label: '不为空'
                      }
                    ]
                  }
                  // 是否会员
                  if (item.selectedOptions[1].split('@')[0] === 'is_vip' && item.selectedOptions[1].split('@')[1] === 'radio') {
                    item.relationOptions = [
                      {
                        value: '=',
                        label: '等于'
                      }
                    ]
                  }
                  // 身份证号
                  if (item.selectedOptions[1].split('@')[0] === 'id_number' && item.selectedOptions[1].split('@')[1] === 'input') {
                    item.relationOptions = [
                      {
                        value: '=',
                        label: '等于'
                      }, {
                        value: 'contain',
                        label: '包含'
                      }, {
                        value: 'empty',
                        label: '为空'
                      },
                      {
                        value: 'not empty',
                        label: '不为空'
                      }
                    ]
                  }
                  // 昵称
                  if (item.selectedOptions[1].split('@')[0] === 'nickname' && item.selectedOptions[1].split('@')[1] === 'input') {
                    item.relationOptions = [
                      {
                        value: '=',
                        label: '等于'
                      }, {
                        value: 'contain',
                        label: '包含'
                      }, {
                        value: 'empty',
                        label: '为空'
                      },
                      {
                        value: 'not empty',
                        label: '不为空'
                      }
                    ]
                  }
                  // 创建时间
                  if (item.selectedOptions[1].split('@')[0] === 'create_time' && item.selectedOptions[1].split('@')[1] === 'datePicker') {
                    item.relationOptions = [
                      {
                        value: 'gt',
                        label: '晚于'
                      }, {
                        value: '=',
                        label: '等于'
                      }, {
                        value: 'lt',
                        label: '早于'
                      }, {
                        value: 'gtele',
                        label: '区间'
                      }, {
                        value: 'empty',
                        label: '为空'
                      },
                      {
                        value: 'not empty',
                        label: '不为空'
                      }
                    ]
                  }
                  // 最后修改时间
                  if (item.selectedOptions[1].split('@')[0] === 'update_time' && item.selectedOptions[1].split('@')[1] === 'datePicker') {
                    item.relationOptions = [
                      {
                        value: 'gt',
                        label: '晚于'
                      }, {
                        value: '=',
                        label: '等于'
                      }, {
                        value: 'lt',
                        label: '早于'
                      }, {
                        value: 'gtele',
                        label: '区间'
                      }, {
                        value: 'empty',
                        label: '为空'
                      },
                      {
                        value: 'not empty',
                        label: '不为空'
                      }
                    ]
                  }
                  // QQ
                  if (item.selectedOptions[1].split('@')[0] === 'qq' && item.selectedOptions[1].split('@')[1] === 'input') {
                    item.relationOptions = [
                      {
                        value: '=',
                        label: '等于'
                      }, {
                        value: 'contain',
                        label: '包含'
                      }, {
                        value: 'empty',
                        label: '为空'
                      },
                      {
                        value: 'not empty',
                        label: '不为空'
                      }
                    ]
                  }
                  // 是否本公司员工
                  if (item.selectedOptions[1].split('@')[0] === 'self_company' && item.selectedOptions[1].split('@')[1] === 'radio') {
                    item.relationOptions = [
                      {
                        value: '=',
                        label: '等于'
                      }
                    ]
                  }
                }
                // 回显群组
                if (item.selectedOptions[0] === 'group') {
                  getGroupList(1, '', 0).then((res) => {
                    for (let item of res.data.data.list) {
                      item.label = item.name
                      item.value = item.id
                    }
                    console.log('re', res)
                    item.option = res.data.data.list
                  })
                }
                // 回显事件
                if (item.selectedOptions[0] === 'event') {
                  // 回显微信公众号
                  if (item.selectedOptions[1] === 'wechat') {
                    getWechatPublicListForNode(1, '').then((res) => {
                      res.data.data.list.unshift({
                        label: '不限',
                        nick_name: '不限',
                        id: '',
                        value: ''
                      })
                      for (let ite of res.data.data.list) {
                        ite.label = ite.nick_name
                        ite.value = ite.id
                        // 扫描线下活动二维码
                        if (item.selectedOptions[2].split('@')[0] === 'scan_offline_qrcode') {
                          if (item.value === ite.id) {
                            item.optionOther = ite.offline
                          }
                        }
                        // 扫描公众号二维码
                        if (item.selectedOptions[2].split('@')[0] === 'scan_qrcode') {
                          if (item.value === ite.id) {
                            item.qrcodeOptions = ite.qrcode
                          }
                          getQrCodeList().then((res) => {
                            console.log('res', res)
                          })
                        }
                        // 发送模板消息
                        if (item.selectedOptions[2].split('@')[0] === 'send_tpl_message') {
                          if (item.value === ite.id) {
                            item.templateOption = ite.template
                          }
                        }
                      }
                      item.option = res.data.data.list
                      console.log('this.forSonTerms', this.forSonTerms)
                    })
                  }
                  // 回显微页面
                  if (item.selectedOptions[1] === 'wepage') {
                    WePagesList(1, { publish_status: '' }).then((res) => {
                      for (let ite of res.data.data.list) {
                        ite.label = ite.admin_title
                        ite.value = ite.id
                      }
                      item.option = res.data.data.list
                    })
                  }
                  // 回显短信
                  if (item.selectedOptions[1] === 'sms') {
                    getMessageListForNode(1, '').then((res) => {
                      for (let ite of res.data.data.list) {
                        ite.label = ite.sms_name
                        ite.value = ite.id
                      }
                      item.option = res.data.data.list
                    })
                  }
                  // 回显互动活动（大转盘）
                  if (item.selectedOptions[1] === 'interactive_activities') {
                    getBigWheelList().then((res) => {
                      for (let ite of res.data.data.list) {
                        ite.label = ite.name
                        ite.value = ite.id
                      }
                      item.option = res.data.data.list
                    })
                  }
                }
                // 回显关注公众号
                if (item.selectedOptions[0] === 'follow_public') {
                  // 回显微信公众号
                  getWechatPublicListForNode(1, '').then((res) => {
                    for (let ite of res.data.data.list) {
                      ite.label = ite.nick_name
                      ite.value = ite.id
                    }
                    item.option = res.data.data.list
                    console.log('this.forSonTerms', this.forSonTerms)
                  })
                }
                // 回显客户身份
                if (item.selectedOptions[0] === 'customer_identity') {
                  item.relationOptions = [
                    {
                      value: 'equal',
                      label: '等于'
                    }, {
                      value: 'not_equal',
                      label: '不等于'
                    }, {
                      value: 'empty',
                      label: '为空'
                    },
                    {
                      value: 'not empty',
                      label: '不为空'
                    }
                  ]
                }
                // 回显微页面
                if (item.selectedOptions[1] === 'wepage') {
                  WePagesList(1, { publish_status: '' }).then((res) => {
                    for (let ite of res.data.data.list) {
                      ite.label = ite.admin_title
                      ite.value = ite.id
                    }
                    item.option = res.data.data.list
                  })
                }
                // 回显短信
                if (item.selectedOptions[1] === 'sms') {
                  getMessageListForNode(1, '').then((res) => {
                    for (let ite of res.data.data.list) {
                      ite.label = ite.sms_name
                      ite.value = ite.id
                    }
                    item.option = res.data.data.list
                  })
                }
                // 回显互动活动（大转盘）
                if (item.selectedOptions[1] === 'interactive_activities') {
                  getBigWheelList().then((res) => {
                    for (let ite of res.data.data.list) {
                      ite.label = ite.name
                      ite.value = ite.id
                    }
                    item.option = res.data.data.list
                  })
                }
                // 客户关键指标
                if (item.selectedOptions[0] === 'customer_kpi') {
                  item.relationOptions = [
                    {
                      value: 'equal',
                      label: '等于'
                    }, {
                      value: 'not_equal',
                      label: '不等于'
                    }, {
                      value: 'gt',
                      label: '大于'
                    },
                    {
                      value: 'lt',
                      label: '小于'
                    },
                    {
                      value: 'gtele',
                      label: '区间'
                    }
                  ]
                }
              }
            }
            this.forSonTerms = terms
            console.log('12121212', this.forSonTerms)
            this.allRelationship = res.data.data.query.query.allRelationship
            this.allTerms = res.data.data.query.query
            this.allTermsCopy = res.data.data.query.query
          }
        }
      })
    },
    // 收起筛选和展开筛选
    closeAndOpen() {
      if (this.hide === true) {
        this.closeChoose = '展开筛选'
        this.hide = false
      } else {
        this.closeChoose = '收起筛选'
        this.hide = true
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // 通过 `vm` 访问组件实例
      let query = JSON.parse(sessionStorage.getItem('groupDetailQuery'))
      vm.isShowSearchRes = true
      if (query) {
        vm.allTerms = query
        vm.isHigher = true
        vm.forSonTerms = vm.allTerms.termsGroup
        vm.allRelationshipSearch = vm.allTerms.allRelationship
        sessionStorage.removeItem('groupDetailQuery')
        vm.preView()
        vm.load()
      } else {
        vm.allTerms = {
          allRelationship: 'and',
          termsGroup: [
            {
              inOperator: 'and',
              terms: [
                {
                  attr: 'attr',
                  attr_label: '真实姓名',
                  relationship: '',
                  relationOptions: [
                    {
                      value: '=',
                      label: '等于'
                    }, {
                      value: '!=',
                      label: '不等于'
                    }, {
                      value: 'contain',
                      label: '包含'
                    }, {
                      value: 'empty',
                      label: '为空'
                    },
                    {
                      value: 'not empty',
                      label: '不为空'
                    }
                  ],
                  value: null,
                  original_id: null,
                  eventAttributeList: [],
                  activitiesTwo: [],
                  templatesTwo: [],
                  wepageTwo: [],
                  eventAttrOptions: [
                    {
                      attributeContent: '',
                      relationOptions: [],
                      sources: [],
                      eventAttrValueOptions: [],
                      attributeRelation: '',
                      attr_type: '',
                      attrValTimeStart: '',
                      attrValTimeEnd: '',
                      attributeValueStart: '',
                      attributeValueEnd: '',
                      attributeValue: ''
                    }
                  ],
                  optionOther: null,
                  qrcodeOptions: null,
                  templateOption: null,
                  qrcode: null,
                  offline_qrcode: null,
                  template_id: null,
                  leave_word: null,
                  public_reply_type_all: {
                    reply_type: '不限',
                    reply_content: ''
                  },
                  eventLimitTime: false,
                  eventLimitTimes: false,
                  eventLimitAttr: false,
                  eventTimeRelation: '',
                  eventDateStart: '',
                  eventDateEnd: '',
                  happenedTimes: '',
                  start_time: '',
                  end_time: '',
                  selectedOptions: ['attr', 'realname@input']
                }
              ]
            }
          ]
        }
        vm.forSonTerms = [
          {
            inOperator: 'and',
            terms: [
              {
                attr: 'attr',
                attr_label: '真实姓名',
                relationship: '',
                relationOptions: [
                  {
                    value: '=',
                    label: '等于'
                  }, {
                    value: '!=',
                    label: '不等于'
                  }, {
                    value: 'contain',
                    label: '包含'
                  }, {
                    value: 'empty',
                    label: '为空'
                  },
                  {
                    value: 'not empty',
                    label: '不为空'
                  }
                ],
                value: null,
                original_id: null,
                eventAttributeList: [],
                activitiesTwo: [],
                templatesTwo: [],
                wepageTwo: [],
                eventAttrOptions: [
                  {
                    attributeContent: '',
                    relationOptions: [],
                    sources: [],
                    eventAttrValueOptions: [],
                    attributeRelation: '',
                    attr_type: '',
                    attrValTimeStart: '',
                    attrValTimeEnd: '',
                    attributeValueStart: '',
                    attributeValueEnd: '',
                    attributeValue: ''
                  }
                ],
                optionOther: null,
                qrcodeOptions: null,
                templateOption: null,
                qrcode: null,
                offline_qrcode: null,
                template_id: null,
                leave_word: null,
                public_reply_type_all: {
                  reply_type: '不限',
                  reply_content: ''
                },
                eventLimitTime: false,
                eventLimitTimes: false,
                eventLimitAttr: false,
                eventTimeRelation: '',
                eventDateStart: '',
                eventDateEnd: '',
                happenedTimes: '',
                start_time: '',
                end_time: '',
                selectedOptions: ['attr', 'realname@input']
              }
            ]
          }
        ]
        vm.isHigher = false
      }
    })
  },
  beforeRouteLeave (to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    if (to.path === '/home/customer-detail') {
      if (this.isHigher === true) {
        sessionStorage.setItem('groupDetailQuery', JSON.stringify(this.allTerms))
      }
    }
    next()
  },
  created() {
    let query = JSON.parse(sessionStorage.getItem('groupDetailQuery'))
    if (!query) {
      this.load()
    }
    this.getCustomerAttributes()
  }
}
</script>

<style scoped>
  .show{
    display: inline-block;
  }
  .hide{
    display: none;
  }
  .refresh{
    font-size: 18px;
    color: #39c6cd;
    cursor: pointer;
  }
  .terms{
    line-height: 20px;
    width: 280px;
    background: #EFFBFB;
    margin: 10px 10px 0 10px;
    font-size: 14px;
    text-align: left;
  }
  .group-detail{
    width: 300px;
    background: #fff;
  }
  .group-detail .title{
    width: 280px;
    height: 60px;
    line-height: 60px;
    color: #333;
    background: #fff;
    border-bottom: 1px solid #E7E7E7;
    text-align: left;
    padding-left: 20px;
  }
  .group-detail .detail-item{
    width: 280px;
    margin: 0 auto;
    border-bottom: 1px solid #e5e5e5;
    height: 50px;
    line-height: 50px;
    display: flex;
    justify-content: space-between;
    color: #666;
    font-size: 14px;
  }
  .detail-item .label{
    width: 100px;
    text-align: right;
  }
  .detail-item .value{
    width: 170px;
    text-align: left;
    padding-left: 10px;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap
  }
  .el-menu-vertical-demo{
    position: relative;
  }
  .add-group-btn{
    width: 20px;
    height: 20px;
    position: absolute;
    top: 18px;
    right: 10px;
  }
  .add-group-btn:hover i{
    color: #1ab394;
  }
  .add-group-btn i{
    display: block;
    font-size: 20px;
    color: #666;
    cursor: pointer;
  }
  .text-align-left{
    text-align: left;
  }
  .text-align-right{
    text-align: right;
  }
  .table-title{
    text-align: left;
  }
  .save-btn{
    padding: 0 15px;
    height: 30px;
    border-radius: 20px;
    text-align: center;
    line-height: 30px;
    float: right;
    color: #fff;
    font-size: 14px;
    background: #1890FF;
    margin-top: 5px;
    cursor: pointer;
  }
  ::-webkit-scrollbar
  {
    width: 6px;  /*滚动条宽度*/
    height: 16px;  /*滚动条高度*/
  }
  /*定义滚动条轨道 内阴影+圆角*/
  ::-webkit-scrollbar-track
  {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 10px;  /*滚动条的背景区域的圆角*/
    background-color: #f5f5f5;/*滚动条的背景颜色*/
  }
  /*定义滑块 内阴影+圆角*/
  ::-webkit-scrollbar-thumb
  {
    border-radius: 10px;  /*滚动条的圆角*/
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    background-color: #ccc;  /*滚动条的背景颜色*/
  }
  .left-menu-item {
    min-width: 266px;
    width: 20%;
    padding: 0;
    padding-bottom: 0px;
    background-color: #fff;
    height: auto;
    box-sizing: border-box;
  }
  .left-menu-item:hover {
    background-color: #fff;
  }
</style>
